import md5 from 'crypto-js/md5';
import type { AddonWhitelist } from '@tencent/td-addon-sdk-docs';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { CUSTOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

const nonce = Math.random().toString();
const IFRAME_SRC_PREFIX = `${CUSTOM.ADDON.IFRAME_URL}?redirect=`;
const ADDON_SCALE_VIEW_PREFIX = 'ad_iframe_';


const getSlideIndex = component => component.parent.presentationRef
    .indexOfSlide(component.parent);

const getURLParams = (aid) => {
    const pid = 'pid_slide_v1.0.0';
    const clientVars: any = SlideDataServices.ClientVarsService()?.getClientVars?.();
    if (clientVars?.globalPadId && clientVars.creatorId) {
        const { globalPadId, creatorId } = clientVars; // window.clientVars中获取
        const docType = 'slide';
        const tinyid = clientVars?.tinyid;
        return `&docType=${docType}&docID=${globalPadId}${tinyid ? `&uid=${tinyid}` : ''}&creator=${creatorId}&addonID=${aid}&packageID=${pid}&nonce=${nonce.split('.')[1]
        }`;
    }
    window?.log?.error('[addon]: get clientVars value error');
    return '';
};

const getIframeSrc = props => `${IFRAME_SRC_PREFIX}${encodeURIComponent(props.addon.embedUrl)}${getURLParams(props.addon.iframeId)}`;

/**
 * 将对象obj转化为md5 string
 * @param obj
 */
const key2md5 = (obj): string => md5(JSON.stringify(obj)).toString();

/**
 * 判断插件url是否为视频类型
 * @param url 插件url
 * @param addonManager
 * @param aid
 */
const isVideoType = (url, addonManager, aid): Promise<any> => addonManager.addonHandler?.emitMessageToAddon('$name', url, aid);

/**
 * 为插件截图组件设置唯一命名
 */
const getAddonScaleViewUniqueName = (): string => `${ADDON_SCALE_VIEW_PREFIX}scale-view`;

/**
 * 判断插件是否在小程序状态下的白名单内
 */
const isInMiniAppRenderWhitelist = (url: string, miniAppRenderWhitelist: AddonWhitelist[]): boolean => {
    const addonUrl = new URL(url);
    if (miniAppRenderWhitelist) {
        return miniAppRenderWhitelist
            .some(whiteURL => whiteURL.pathList
                .some(whitePath => whiteURL.host === addonUrl.host && addonUrl.pathname.match(whitePath)));
    }
    return false;
};

export {
    getSlideIndex,
    getIframeSrc,
    isVideoType,
    getAddonScaleViewUniqueName,
    key2md5,
    isInMiniAppRenderWhitelist,
};
